import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import Validator from '../../../lib/validator';
import date from '../../../lib/date';
import { ClearLocalStorageAll, ClearForm } from '../../../lib/clearLocalStorage'
import { verifyKTP } from '../../../bpjs-api/api'
import Loading from '../../Loading'

import {red500} from 'material-ui/styles/colors';
import TextDesc from './text_desc';
import IconDesc from './icon_desc';
import TitleForm from './form_title';
import { getToken } from '../../../bpjs-api/authorized-request'

let styles = {
  errorField: {
    border: 'solid 1px #D0021B'
  }
}

class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        NIK: ((localStorage.getItem("NIK") !== null) ? localStorage.getItem("NIK") : ''),
        NamaLengkap: ((localStorage.getItem("NamaLengkap") !== null) ? localStorage.getItem("NamaLengkap") : ''),
        ThnLahir: ((localStorage.getItem("ThnLahir") !== null) ? localStorage.getItem("ThnLahir") : ''),
        BlnLahir: ((localStorage.getItem("BlnLahir") !== null) ? localStorage.getItem("BlnLahir") : ''),
        TglLahir: ((localStorage.getItem("TglLahir") !== null) ? localStorage.getItem("TglLahir") : ''),
      },
      errorValidator: {
        errorNIK: false,
        errorNamaLengkap: false,
        errorThnLahir: false,
        errorBlnLahir: false,
        errorTglLahir: false,
        // add to show error form 
        errorForm: ((localStorage.getItem("formError") !== null) ? true : false),
        // add error message by alfan
        errorNIKMessage: null,
        errorNamaLengkapMessage: null,
        errorThnLahirMessage: null,
        errorBlnLahirMessage: null,
        errorTglLahirMessage: null,
      },
      loading: false
    }
    this.baseState = this.state
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { data } = this.state;
    data[event.target.name] = event.target.value;
    localStorage.setItem(event.target.name, data[event.target.name]);
    this.setState({ data });

    // validator made by alfan
    this.errorHandler(event.target.name, event.target.value)
  }

  dismissError () {
    const { errorValidator } = this.state;
    // console.log(!errorValidator.errorForm)
    errorValidator.errorForm = !errorValidator.errorForm

    ClearForm()

    this.setState({ errorValidator });
  }

  // form validator made by alfan
  errorHandler(key,  value='') {
    // console.log('------ key error handler', key, value)

    switch (key) {
      case 'NIK': {
        if (value === '') {
          this.state.errorValidator.errorNIK = true
          this.state.errorValidator.errorNIKMessage = 'NIK tidak boleh kosong'
        } else {
          this.state.errorValidator.errorNIK = value.match(/^[0-9]{16,16}$/) === null
          this.state.errorValidator.errorNIK ? this.state.errorValidator.errorNIKMessage = 'NIK terdiri dari 16 digit angka tanpa huruf atau karakter spesial (!@#$%^&*)' : ''
        }
      } break;
      case 'NamaLengkap': {
        if ( value === '') {
          this.state.errorValidator.errorNamaLengkap = true
          this.state.errorValidator.errorNamaLengkapMessage = 'Nama harus di isi'
        } else {
          this.state.errorValidator.errorNamaLengkap = value.match(/^[a-zA-Z ]+$/) === null

          this.state.errorValidator.errorNamaLengkap ? this.state.errorValidator.errorNamaLengkapMessage = 'Nama tidak boleh terdapat angka atau karakter spesial' : ''
        }
      } break;
      case 'ThnLahir': {
        value === '' ? this.state.errorValidator.errorThnLahir = true : this.state.errorValidator.errorThnLahir = false
      } break;
      case 'BlnLahir': {
        value === '' ? this.state.errorValidator.errorBlnLahir = true : this.state.errorValidator.errorBlnLahir = false
      } break;
      case 'TglLahir': {
        value === '' ? this.state.errorValidator.errorTglLahir = true : this.state.errorValidator.errorTglLahir = false
      }
    }
  }

  // check data before sent 
  checkData (data, callback) {

    // check to validator first
    try {
      for (var key in this.state.data) {
        this.errorHandler(key, this.state.data[key])
      }
    }
    catch (err) {
      console.log(err)
    }
    finally {
      // check error
      for (var key in data) {
        if (data[key] === true) {
          if (key !== 'errorForm') {
            return callback(true)
          }
        }
      }
      return callback(false)
    }
  }

  submit(event) {


    const { route } = this.props;
    const { errorValidator } = this.state;
    let _this = this;

    //check data before to the next step
    this.checkData(this.state.errorValidator, async (check) => {
      // console.log('callback', check)
      if (check === true) {
        Validator(this.state.data).then(result => {
          // console.log('result',result)
          result.forEach((val, index) => {
            this.errorHandler(val)

            errorValidator['error' + val] = true;
            _this.setState({ errorValidator });

            console.log('error')
          })
        })
      } else {
        localStorage.setItem('step_status', 0);
        localStorage.setItem('NIK', this.state.data.NIK)
        localStorage.setItem('NamaLengkap', this.state.data.NamaLengkap)
        localStorage.setItem('ThnLahir', this.state.data.ThnLahir)
        localStorage.setItem('BlnLahir', this.state.data.BlnLahir)
        localStorage.setItem('TglLahir', this.state.data.TglLahir)
        localStorage.setItem('NoPonsel', '081234567890')

        _this.setState({ loading: true})

        try {
          const token = await getToken()
          localStorage.setItem("token", token.data.token)
        } catch(error) {
          localStorage.setItem('formError', error)
          errorValidator.errorForm = true;
          _this.setState({ 
            errorValidator,
            loading: false
          })
        }
        // dont forget to test 
        if (process.env.NODE_ENV !== 'development') {
          const peserta = localStorage
          try {
            const result = await verifyKTP(peserta)
            // console.log('result----',result)
            
            // add address to localstorage
            localStorage.setItem('Alamat', result.data.ALAMAT_KTP + ' Kel.' + result.data.KEL_KTP + ' Kec.' + result.data.KEC_KTP + ' Kab.' + result.data.KAB_KTP + ', ' + result.data.PROP_KTP + ', ' + result.data.KODEPOS_KTP)

            // push to next step
            route.history.push('/step')
          } catch (error) {
            // console.log('error----',error)
            localStorage.setItem('formError', error.msg)
            errorValidator.errorForm = true;
            _this.setState({ 
              errorValidator,
              loading: false
            })
          }
        } else {
          route.history.push('/step')
        }
      }
    })
  

    // const { route } = this.props;
    // const { errorValidator } = this.state;
    // let _this = this;

    // Validator(this.state.data).then(result => {
    //   if (result.length === 0) {
    //     localStorage.setItem('step_status', 0);
    //     localStorage.setItem('NIK', this.state.data.NIK)
    //     localStorage.setItem('NamaLengkap', this.state.data.NamaLengkap)
    //     localStorage.setItem('ThnLahir', this.state.data.ThnLahir)
    //     localStorage.setItem('BlnLahir', this.state.data.BlnLahir)
    //     localStorage.setItem('TglLahir', this.state.data.TglLahir)
    //     // route.history.push('/step')
    //   }else {
    //     result.forEach((val, index) => {
    //       this.errorHandler(val)

    //       errorValidator['error'+val] = true;
    //       _this.setState({ errorValidator });
    //     })
    //   }

    // })
  }

  // handle reset form
  resetForm = () => {
    this.setState(this.baseState.data)
  }

  componentWillMount () {
    // celar local storage when refresh 
    ClearLocalStorageAll()

    // initiate reset state
    this.resetForm()

    // console.log(process.env)
  }

  render() {
    const {NIK, NamaLengkap, ThnLahir, BlnLahir, TglLahir} = this.state.data;
    const { data } = this.state;
    const { errorNIK, errorNamaLengkap, errorThnLahir, errorBlnLahir, errorTglLahir } = this.state.errorValidator;

    let errorFieldNIK, errorFieldNamaLengkap, errorFieldThnLahir, errorFieldBlnLahir, errorFieldTglLahir;
    (errorNIK) ? errorFieldNIK = {border: 'solid 1px #D0021B'} : '';
    (errorNamaLengkap) ? errorFieldNamaLengkap = {border: 'solid 1px #D0021B'} : '';
    (errorThnLahir) ? errorFieldThnLahir = {border: 'solid 1px #D0021B'} : '';
    (errorBlnLahir) ? errorFieldBlnLahir = {border: 'solid 1px #D0021B'} : '';
    (errorTglLahir) ? errorFieldTglLahir = {border: 'solid 1px #D0021B'} : '';

    return(
      <div className="container" id="content">
        <div className="row" >
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 content-col">

            <TextDesc />

            <IconDesc />

          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 box-intro-form">
            <div className="w3-container w3-padding-32 custom-container-form">
              {/* Loading when check data */}
              <Loading isLoading={this.state.loading} />
              
              <TitleForm />

              {/* error notification top */}
              {
                this.state.errorValidator.errorForm ? 
                  <div style={{ height: 'auto', fading: true }} className="alert alert-warning">
                    <button type="button" className="close" onClick={(event) => { this.dismissError() }}>&times;</button>
                    <p style={{ color: red500 }}>{(localStorage.formError !== '') ? localStorage.formError : ''}</p>
                  </div> 
                : null
              }
              
              
              <div className="w3-container w3-padding-16">
                <form>

                  <label className="custom-label"><b>NIK (Nomor Induk Kependudukan)</b></label>
                  <input onChange={(val) => this.onChange(val)} value={NIK} name="NIK" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={errorFieldNIK}/>

                  {
                    // error message for nik modified by alfan 
                    (errorNIK) ? <p className="custom-error-field">{this.state.errorValidator.errorNIKMessage}</p> : ''
                  }

                  <label className="custom-label"><b>Nama Lengkap</b></label>
                  <input onChange={(val) => this.onChange(val)} value={NamaLengkap} name="NamaLengkap" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={errorFieldNamaLengkap}/>

                  {
                    // error message for name modified by alfan
                    (errorNamaLengkap) ? <p className="custom-error-field">{this.state.errorValidator.errorNamaLengkapMessage}</p> : ''
                  }

                  <label className="custom-label"><b>Tanggal Lahir</b></label>
                  <div className="w3-row" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <div className="w3-col l4 m4 w3-margin-bottom" style={{width: '110px'}}>
                      <select onChange={(val) => {this.setState({data: {...data, ThnLahir: val.target.value}}); localStorage.setItem('ThnLahir', val.target.value);}} className="w3-select w3-margin-top custom-field" name="option" style={errorFieldThnLahir} value={ThnLahir}>
                        <option value=''> --- </option>
                        { date().years.map(year => (<option key={year.key} value={year.value}>{year.text}</option>)) }
                      </select>
                    </div>
                    <div className="w3-col l4 m4 w3-margin-bottom" style={{width: '110px'}}>
                      <select onChange={(val) => { this.setState({ data: { ...data, BlnLahir: val.target.value } }); localStorage.setItem('BlnLahir', val.target.value); }} className="w3-select w3-margin-top custom-field" name="option" style={errorFieldBlnLahir} value={BlnLahir}>
                        <option value=''> --- </option>
                        { date().months.map(month => (<option key={month.key} value={month.value}>{month.text}</option>)) }
                      </select>
                    </div>
                    <div className="w3-col l4 m4 w3-margin-bottom" style={{width: '110px'}}>
                      <select onChange={(val) => { this.setState({ data: { ...data, TglLahir: val.target.value } }); localStorage.setItem('TglLahir', val.target.value); }} className="w3-select w3-margin-top custom-field" name="option" style={errorFieldTglLahir} value={TglLahir}>
                        <option value=''> --- </option>
                        { date().dates.map(day => (<option key={day.key} value={day.value}>{day.text}</option>)) }
                      </select>
                    </div>
                  </div>
                  {(errorThnLahir || errorBlnLahir || errorTglLahir) ? <p className="custom-error-field">Tanggal lahir belum lengkap</p> : ''}
                </form>
              </div>
              <div className="w3-container w3-padding-16" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button id="send_participant" className="w3-btn w3-blue w3-block" onClick={(event) => this.submit(event)} >MULAI</button>
              </div>
              <div className="w3-container w3-padding-16" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#B7BCBF', fontSize: '10px'}}>
                <i className="fa fa-lock" aria-hidden="true"></i><p style={{marginLeft: '10px', marginTop: '10px'}}>Informasi Anda tersimpan aman</p>
              </div>
              {/* Move error to the top */}
              {/* <div style={{height: '100px'}}><span style={{color: red500}}>{(localStorage.formError !== '') ? localStorage.formError : ''}</span></div> */}
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/component/Home/Content/index.js